import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiBell, FiCheckCircle, FiDollarSign, FiAlertTriangle,
  FiHome, FiMessageSquare, FiCalendar, FiTrendingUp,
  FiFilter, FiCheck, FiTrash2, FiUser, FiStar,
  FiChevronLeft, FiChevronRight, FiX, FiEye, FiClock,
  FiMapPin, FiTag,
  FiHelpCircle,
  FiUserCheck,
  FiCpu
} from 'react-icons/fi';
import '../../../assets/css/Buyer/dashboard/buyernotifications/buyernotifications.css';
import axios from 'axios';
import AppContext from 'context/AppContext';
import BuyerMasterLayout from 'layouts/BuyerMasterLayout';
import echo from 'echo';

/* ══════════════════════════════════════════════════════════
   NOTIFICATION DETAIL MODAL
══════════════════════════════════════════════════════════ */
const NotifDetailModal = ({ notification, onClose }) => {
  const [title, setTitle] = useState();
  const [subtitle, setSubtitle] = useState();
  const [category, setCategory] = useState();
  const [description, setDescription] = useState();
  const [isRead, setIsRead] = useState('unread');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  if (!notification) return null;

  return (
    <div className="notif-modal-overlay" onClick={onClose}>
      <div className="notif-modal" onClick={e => e.stopPropagation()}>

        {/* ── Header ── */}
        <div className="notif-modal__header">
          <div className="notif-modal__header-left">
            {/* Icon */}
            <div
              className="notif-modal__icon"
              style={{ background: `${notification.color}18`, color: notification.color }}
            >
              {notification.avatar
                ? <img src={notification.avatar} alt="" className="notif-modal__avatar-img" />
                : notification.icon
              }
            </div>
            <div>
              <h3 className="notif-modal__title"
                onChange={(e) => setTitle(e.target.velue)}
              >
                {notification.title}
                {notification.subtitle && (
                  <span className="notif-modal__subtitle"
                    onChange={(e) => setSubtitle(e.target.velue)}
                  > {notification.subtitle}</span>
                )}
              </h3>
              <div className="notif-modal__meta">
                <span className="notif-modal__type-badge"
                  style={{ background: `${notification.color}15`, color: notification.color }}>
                  {notification.category}
                </span>
                <span className="notif-modal__time">
                  <FiClock size={11} /> {notification.time} · {notification.date}
                </span>
                {!notification.isRead && (
                  <span className="notif-modal__unread-chip">Unread</span>
                )}
              </div>
            </div>
          </div>
          <button className="notif-modal__close" onClick={onClose}>
            <FiX size={16} />
          </button>
        </div>

        {/* ── Accent bar ── */}
        <div className="notif-modal__accent" style={{ background: notification.color }} />

        {/* ── Body ── */}
        <div className="notif-modal__body">

          {/* Message */}
          <div className="notif-modal__section">
            <p className="notif-modal__section-label">
              <FiMessageSquare size={13} /> Description
            </p>
            <p className="notif-modal__message"
              onChange={(e) => setDescription(e.target.velue)}
            >{notification.description}</p>
          </div>

          {/* Action hint */}
          {notification.action && (
            <div className="notif-modal__section">
              <p className="notif-modal__section-label">
                <FiTag size={13} /> Action Required
              </p>
              <p className="notif-modal__action-text">{notification.action}</p>
            </div>
          )}

          {/* Details grid */}
          <div className="notif-modal__section">
            <p className="notif-modal__section-label">
              <FiAlertTriangle size={13} /> Details
            </p>
            <div className="notif-modal__detail-grid">
              <div className="notif-modal__detail-row">
                <span className="notif-modal__detail-label">Category</span>
                <span className="notif-modal__detail-val" style={{ textTransform: 'capitalize' }}
                  onChange={(e) => setCategory(e.target.velue)}
                >
                  {notification.category}
                </span>
              </div>
              <div className="notif-modal__detail-row">
                <span className="notif-modal__detail-label">Date</span>
                <span className="notif-modal__detail-val">{notification.date}</span>
              </div>
              <div className="notif-modal__detail-row">
                <span className="notif-modal__detail-label">Time</span>
                <span className="notif-modal__detail-val">{notification.time}</span>
              </div>
              <div className="notif-modal__detail-row">
                <span className="notif-modal__detail-label">Status</span>
                <span className={`notif-modal__detail-val ${notification.isRead ? 'notif-modal__val--read' : 'notif-modal__val--unread'}`}
                  onChange={(e) => setIsRead(e.target.velue)}
                >
                  {notification.isRead ? 'Read' : 'Unread'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="notif-modal__footer">
          <button className="notif-modal__close-btn" onClick={onClose}>
            Close
          </button>
          {notification.module && (
            <button
              className="notif-modal__goto-btn"
              onClick={onClose}
            >
              Go to Page →
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════════════ */
const BuyerNotification = () => {
  const { baseUrl, loggedInBuyer, authToken } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState('all');
  const [errorMessage, setErrorMessage] = useState();
  const [viewNotif, setViewNotif] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [notifications, setNotifications] = useState([
    // { id: 1,
    //   category: 'booking',  
    //   icon: <FiCalendar />,     
    //   color: '#3b82f6', 
    //   title: 'Yuko Tricarico',     
    //   subtitle: 'from Japan (User ID: 5620)', 
    //   description: 'made a new booking for Soba Orgulje apartment from 04.01.2017 - 09.01.2017.',                                          
    //   action: 'Click here to view booking details.',    
    //   time: '10:30 PM', 
    //   date: 'Today',     
    //   is_read: false },
    // { id: 2,  category: 'payment',  icon: <FiDollarSign />,   color: '#10b981', title: 'New payment',        subtitle: 'of 600 EUR received from Ouida Lockley', description: 'for Easter Special booking at Ap. Donat apartment.',                                                          time: '10:10 PM', date: 'Today',     isRead: false },
    // { id: 3,  category: 'user',     icon: <FiUser />,         color: '#f59e0b', title: 'Samina Tariq',       subtitle: '(samina@email.com)',         description: 'has signed up as a new user.',                                                                                           action: 'Click to view profile.',                 time: '9:45 PM',  date: 'Today',     isRead: false },
    // { id: 4,  category: 'warning',  icon: <FiAlertTriangle />,color: '#dc2626', title: 'System Warning:',    subtitle: '3 failed login attempts detected in the past hour.', description: 'IP: 192.158.1.38 for buyer.',                                                                   time: '8:15 PM',  date: 'Today',     isRead: false },
    // { id: 5,  category: 'property', icon: <FiHome />,         color: '#6366f1', title: 'Modern Family House',subtitle: 'status changed to "Sold".',  description: 'Click to view property details.',                                                                                        time: '06:25 PM', date: 'Yesterday', isRead: true  },
    // { id: 6,  category: 'message',  icon: <FiMessageSquare />,color: '#8b5cf6', title: 'New message from Sarah Khan:', description: '"Hi, please update the property listing for Gulberg Heights Apartment based on our recent discussion"', action: 'Click to view message.', time: '05:30 PM', date: 'Yesterday', isRead: true, avatar: 'https://i.pravatar.cc/150?img=5' },
    // { id: 7,  category: 'booking',  icon: <FiCalendar />,     color: '#3b82f6', title: 'Lev Patrick',        description: 'has created a new booking for DHA Phase 5 Villa from 01.01.2017 to 10.01.2017.',                                                                                  time: '01:10 PM', date: 'Sunday',    isRead: true  },
    // { id: 8,  category: 'report',   icon: <FiTrendingUp />,   color: '#10b981', title: 'CityEstate Network', description: "'s performance report for this month is now available.",                                                                                                          time: '11:20 AM', date: 'Sunday',    isRead: true  },
    // { id: 9,  category: 'rating',   icon: <FiStar />,         color: '#f59e0b', title: 'New Rating',         subtitle: 'Ahmed Ali received 5 stars',description: 'from John Doe for excellent service.',                                                                                    time: '09:15 AM', date: 'Sunday',    isRead: true  },
    // { id: 10, category: 'dispute',  icon: <FiAlertTriangle />,color: '#dc2626', title: 'Jamila Torgenson',   description: 'has cancelled her booking for Ap. Stošija from 10.01.2017 to 14.01.2017.',                                                                                        action: 'Click here to view cancellation details.', time: '00:50 PM', date: 'Saturday', isRead: true },
  ]);

  const filteredNotifications = notifications.filter(n => {
    if (activeTab === 'all') return true;
    if (activeTab === 'unread') return !n.isRead;
    if (activeTab === 'read') return n.isRead;
    return true;
  });

  const viewAllBuyerNotification = () => {
    setLoading(true);
    axios.get(`${baseUrl}/buyer/notification/viewAllBuyerNotification`, {
      headers: {
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          const updatedNotifications = response.data.notifications.map((item) => {
            let icon = <FiBell />;
            let color = "#3b82f6";

            const category = (item.category || '').toLowerCase().trim();

            if (category === "wishlist") {
              icon = <FiUserCheck />;
              color = "#3b82f6";
            }
            else if (category === "designvisionai") {
              icon = <FiCpu />;
              color = "#10b981";
            }
            else if (category === "visit request") {
              icon = <FiUserCheck />;
              color = "#dc2626";
            }
            else if (category === "message") {
              icon = <FiMessageSquare />;
              color = "#8b5cf6";
            }
            else if (category === "helpsupport") {
              icon = <FiHelpCircle />;
              color = "#f59e0b";
            }
            return { ...item, icon, color };
          });
          setNotifications(updatedNotifications);
          setLoading(false);
        }

        else if (response.data.succes == false) {
          setErrorMessage(response.data.message)
          setLoading(false);
        }
      }).catch((error) => {
        console.log(error);
        setLoading(false);
      })
  }

  const markAsRead = (notif) => {
    const formData = new FormData();
    formData.append('id', notif.id)
    axios.post(`${baseUrl}/buyer/notification/markAsRead`, formData, {
      headers: {
        "Content-Type": "multipart-formdata",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then((response) => {
        console.log("resposne called", response.data);
        if (response.data.success == true) {
          setNotifications(prev => prev.map(n => n.id === notif.id ? { ...n, isRead: true } : n));
        }
        else if (response.data.succes == false) {
          setErrorMessage(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const markAllAsRead = () => {
    axios.post(`${baseUrl}/buyer/notification/markAllAsRead`, {
      headers: {
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log("resposne called", response.data);
        if (response.data.success == true) {
          setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
        }
        else if (response.data.succes == false) {
          setErrorMessage(response.data.message)

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const audioRef = useRef(new Audio("/notification.mp3"));
  const isAudioUnlocked = useRef(false);
  const deleteNotification = (notif) => {
    console.log("**********", notifications);
    const formdata = new FormData();
    formdata.append("id", notif.id);
    axios.post(`${baseUrl}/buyer/notification/deleteNotification`, formdata, {
      headers: {
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log(response.data);
        viewAllBuyerNotification();
      })
      .catch((error) => console.log(error));
  };
  const playNotificationSound = () => {
    audioRef.current.currentTime = 0;
    audioRef.current.play()
      .then(() => console.log("✅ Sound Played"))
      .catch(err => console.log("❌ Audio Error", err));
  };



  const counts = {
    all: notifications.length,
    unread: notifications.filter(n => !n.isRead).length,
    read: notifications.filter(n => n.isRead).length,
  };

  const totalPages = Math.ceil(filteredNotifications.length / itemsPerPage);
  const paginated = filteredNotifications.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );



  const handleView = (e, notif) => {
    e.stopPropagation();
    markAsRead(notif);
    setViewNotif(notif);
  };

  useEffect(() => {
    const unlockAudio = () => {
      if (!isAudioUnlocked.current) {
        audioRef.current.play()
          .then(() => {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            isAudioUnlocked.current = true;
            console.log("🔓 Audio unlocked");
          })
          .catch(() => {});
      }
      document.removeEventListener('click', unlockAudio);
    };

    document.addEventListener('click', unlockAudio);
    return () => document.removeEventListener('click', unlockAudio);
  }, []);

  useEffect(() => {
    if (!loggedInBuyer?.id) return; // id available na ho to subscribe hi mat karo

    const channelName = `buyer.${loggedInBuyer.id}`;

    echo.private(channelName)
      .subscribed(() => console.log("✅ Subscribed to", channelName))
      .error((error) => console.log("❌ Channel Subscription Error", error))
      .listen(".notification.created", (e) => {
        console.log("🔥 Event Received", e);
        viewAllBuyerNotification();
        playNotificationSound();
      });

    viewAllBuyerNotification();

    return () => {
      echo.leaveChannel(`private-${channelName}`); // leave() ki jagah leaveChannel() poora naam ke sath
    };
  }, [loggedInBuyer?.id]); // dependency array mein id daalo, khali [] ki jagah

  return (
    <BuyerMasterLayout>
      <div className="notifications-page">

        {/* ── Page Header ── */}
        <div className="notifications-header">
          <div className="notif-header-left">
            <h1 className="notif-page-title">Notifications</h1>
          </div>
          {/* <button className="notif-mark-all-btn" onClick={markAllAsRead}>
            <FiBell size={16} />
            Mark All as Read
          </button> */}
        </div>

        {/* ── Filter Tabs ──
        <div className="notifications-filters">
          <div className="notif-filter-tabs">
            {['all', 'unread', 'read'].map(tab => (
              <button
                key={tab}
                className={`notif-filter-tab ${activeTab === tab ? 'active' : ''}`}
                onClick={() => { setActiveTab(tab); setCurrentPage(1); }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                <span className="notif-tab-count">{counts[tab]}</span>
              </button>
            ))} 
          </div>
          {/* <button className="notif-filter-dropdown-btn">
            <FiFilter size={14} /> Filter
          </button>
        </div> */}

        {/* ── Notifications List ── */}
        <div className="notif-notifications-list">
          {loading ? (

            <div className="notif-loader">
              <span
                className="spinner-border spinner-border "
                role="status"
              ></span>

              <p className="mt-3">Loading Notifications...</p>
            </div>

          ) : paginated.length === 0 ? (

            <div className="notif-empty-state">
              <FiBell size={48} />
              <h3>No notifications</h3>
              <p>You're all caught up!</p>
            </div>

          ) : (
            paginated.map((notif, idx) => (
              <div
                key={notif.id}
                className={`notification-item ${!notif.isRead ? 'unread' : ''}`}
                onClick={() => markAsRead(notif)}
                style={{ animationDelay: `${idx * 0.05}s` }}
              >
                {/* Left border */}
                <div className="notification-border" style={{ background: notif.color }} />

                {/* Icon */}
                <div className="notification-icon"
                  style={{ background: `${notif.color}15`, color: notif.color }}>
                  {notif.avatar
                    ? <img src={notif.avatar} alt="" className="notif-avatar" />
                    : notif.icon
                  }
                </div>

                {/* Content */}
                <div className="notification-content">
                  <div className="notification-title">
                    <span className="notif-title-bold">{notif.title}</span>
                    {notif.subtitle && (
                      <span className="notif-title-normal"> {notif.subtitle}</span>
                    )}
                  </div>
                  <p className="notification-message">{notif.description}</p>
                  {notif.action && (
                    <span className="notification-action">{notif.action}</span>
                  )}
                </div>

                {/* Right side */}
                <div className="notification-right">
                  <div className="notification-time">
                    <span className="notif-time">{notif.time}</span>
                    <span className="notif-date">{notif.date}</span>
                  </div>

                  <div className="notification-actions">
                    {/* Mark read */}
                    {!notif.isRead && (
                      <button
                        className="notif-action-btn notif-mark-read-btn"
                        title="Mark as read"
                        // onClick={e => { e.stopPropagation(); markAsRead(notif.id); }}
                        onClick={markAsRead(notif)}
                      >
                        <FiCheck size={14} />
                      </button>
                    )}

                    {/* ── VIEW BUTTON (replaces FiMoreVertical) ── */}
                    <button
                      className="notif-action-btn notif-view-btn"
                      title="View Details"
                      onClick={e => handleView(e, notif)}
                    >
                      <FiEye size={14} />
                    </button>

                    {/* Delete */}
                    <button
                      className="notif-action-btn notif-delete-btn"
                      title="Delete"
                      onClick={() => deleteNotification(notif)}
                    >
                      <FiTrash2 size={14} />
                    </button>
                  </div>
                </div>

                {/* Unread dot */}
                {!notif.isRead && <div className="notif-unread-indicator" />}
              </div>
            ))
          )}
        </div>

        {/* ── Pagination ── */}
        {totalPages > 1 && (
          <div className="pagination-section">
            <div className="pagination-controls">
              <button className="pagination-btn" disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}>
                <FiChevronLeft size={15} />
              </button>
              {[...Array(Math.min(5, totalPages))].map((_, i) => {
                const n = i + 1;
                return (
                  <button key={n}
                    className={`pagination-number ${currentPage === n ? 'active' : ''}`}
                    onClick={() => setCurrentPage(n)}>
                    {n}
                  </button>
                );
              })}
              <button className="pagination-btn" disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}>
                <FiChevronRight size={15} />
              </button>
            </div>
          </div>
        )}

        {/* ── Detail Modal ── */}
        {viewNotif && (
          <NotifDetailModal
            notification={viewNotif}
            onClose={() => setViewNotif(null)}
          />
        )}
      </div>
    </BuyerMasterLayout>
  );
};

export default BuyerNotification;